<template>
  <v-form
    id="payment-form"
    @submit="createPaymentMethod"
    v-model="formState"
    :disabled="formSubmitted"
    @submit.prevent
  >
    <v-card-title class="pa-1">Enter your card details</v-card-title>
    <v-card-text class="px-4">
      <v-container>
        <v-row>
          <span v-if="plan">
            <v-icon small>mdi-arrow-right</v-icon> Total due now
            {{ $filters.currency(plan.amountInCents / 100) }}
          </span>
        </v-row>
        <v-row v-if="plan">
          <span>
            <v-icon small>mdi-arrow-right</v-icon> Subscribing to
            <strong>{{ plan.name }}</strong>
          </span>
        </v-row>
        <v-row class="py-2">
          <v-text-field
            v-model="cardName"
            ref="cardName"
            solo
            hide-details
            dense
            outlined
            :rules="[(v) => !!v || 'Card name is required']"
            flat
            label="Card name"
            prepend-inner-icon="mdi-account"
            class="card-details--name"
          ></v-text-field>
        </v-row>
        <v-row>
          <div
            id="card-element"
            style="
              width: 100%;
              border: 1px solid grey;
              padding: 10px;
              border-radius: 4px;
            "
          ></div>
          <div id="card-element-errors" role="alert"></div>
        </v-row>
        <v-row class="pt-2">
          <v-btn
            type="submit"
            color="primary"
            :disabled="!formValid() || formSubmitted"
            block
            :loading="formSubmitted"
          >
            Subscribe
          </v-btn>
        </v-row>
      </v-container>
    </v-card-text>
  </v-form>
</template>
<script>
import { createSubscription } from '@/services/subscriptions'
import { mapActions, mapState } from 'vuex'
import { settings } from '@/utils/settings'

// eslint-disable-next-line no-undef
const stripe = Stripe(settings.STRIPE_PUBLIC_KEY)
const elements = stripe.elements()
let card

export default {
  props: {
    plan: {
      type: Object,
      required: false
    }
  },

  data: () => ({
    formState: false,
    stripeCardValid: false,
    formSubmitted: false,
    cardName: undefined
  }),

  mounted() {
    const style = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }

    card = elements.create('card', { style, hidePostalCode: true })
    card.on('change', (e) => {
      this.displayCardError(e)
    })
    card.mount('#card-element')
    this.focus()
  },

  beforeUnmount() {
    card.clear()
    card.destroy()
  },

  computed: {
    ...mapState('preferences', ['selectedSupplierId']),
    ...mapState('profile', {
      stripeCustomerId: (state) => state.info?.stripeCustomerId
    })
  },

  methods: {
    ...mapActions('profile', ['fetchSupplierProfile']),

    focus() {
      this.$nextTick(() => {
        this.$refs.cardName.focus()
      })
    },

    formValid() {
      return this.formState && this.stripeCardValid
    },

    displayCardError(e) {
      const cardErrorEl = document.getElementById('card-element-errors')
      cardErrorEl.textContent = e.error?.message || ''
      this.stripeCardValid = !e.error
    },

    async createPaymentMethod(e) {
      e.preventDefault()
      this.formSubmitted = true

      try {
        const result = await stripe.createPaymentMethod({
          type: 'card',
          card,
          billing_details: {
            name: this.cardName
          }
        })
        if (result.error) {
          this.displayCardError(result)
        } else {
          try {
            await createSubscription(this.selectedSupplierId, {
              customerId: this.stripeCustomerId,
              paymentMethodId: result.paymentMethod.id,
              priceId: this.plan.priceId
            })
            this.fetchSupplierProfile(this.selectedSupplierId)
            this.$router.push({ name: 'subscription-created' })
          } catch (e) {
            console.error(e)
            this.addNotification({
              color: 'error',
              text: 'Unable to create your Stripe subscription. Please try again...'
            })
          }
        }
      } catch (e) {
        console.error(e)
        this.displayCardError(e)
      }
      this.formSubmitted = false
    }
  }
}
</script>
<style lang="scss" scoped></style>
